import moment from 'moment'

const filter = {
  filteDate(date) {
    if (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    } else {
      return ''
    }
  },

  filteYearMonthDate(date) {
    if (date) {
      return moment(date).format('YYYY-MM-DD')
    } else {
      return ''
    }
  },

  // 一般状态
  filteStatus(status, key) {
    const statusList = {
      0: { name: 'pubilc.close', color: '#f50' },
      1: { name: 'pubilc.open', color: 'green' },
    }
    const returnStatus = statusList[status] || {}
    return returnStatus[key] || ''
  },

  // 性别
  filteGender(gender, key) {
    const genderList = {
      male: {
        name: '男',
        color: '#1890ff',
        icon: 'man',
        translate: 'public.male',
      },
      female: {
        name: '女',
        color: '#eb2f96',
        icon: 'woman',
        translate: 'public.female',
      },
    }
    const returnGender = genderList[gender] || {}

    return returnGender[key] || ''
  },

  // 年级
  filteGrade(gradeType, key) {
    const gradeList = {
      9: { name: 'Pre-10' },
      10: { name: '10' },
      11: { name: '11' },
      12: { name: '12' },
    }
    const returnGender = gradeList[gradeType] || {}
    return returnGender[key] || ''
  },
}

export default filter
